/// Menu
import React, {
  useContext,
  useReducer,
  useState
} from "react";

import PerfectScrollbar from "react-perfect-scrollbar";

import { Link, NavLink } from "react-router-dom";

import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
import { MenuSuperAdmin } from "./afiliado";

const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = {
  active: "",
  activeSubmenu: "",
};

const SideBar = () => {
  const { iconHover, sidebarposition, headerposition, sidebarLayout } =
    useContext(ThemeContext);
  //const storage = JSON.parse(window.localStorage.getItem("userDetails"));

  const [state, setState] = useReducer(reducer, initialState);

  //For scroll
  const [hideOnScroll, setHideOnScroll] = useState(true);
  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y;
      if (isShow !== hideOnScroll) setHideOnScroll(isShow);
    },
    [hideOnScroll]
  );

  const handleMenuActive = (status) => {
    if (state.active === status) {
      setState({ active: "" });
    } else {
      setState({ active: status });
    }
  };

  const handleSubmenuActive = (status) => {
    if (state.activeSubmenu === status) {
      setState({ activeSubmenu: "" });
    } else {
      setState({ activeSubmenu: status });
    }
  };

  /// Path
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  return (
    <div
      className={`deznav  border-right ${iconHover} ${
        sidebarposition.value === "fixed" &&
        sidebarLayout.value === "horizontal" &&
        headerposition.value === "static"
          ? hideOnScroll > 120
            ? "fixed"
            : ""
          : ""
      }`}
    >
      <PerfectScrollbar className="deznav-scroll">
     
          <ul className="metismenu" id="menu">
            {MenuSuperAdmin.map((data, index) => {
              let menuClass = data.classsChange;
              if (menuClass === "menu-title") {
                return (
                  <li className={menuClass} key={index}>
                    {data.title}
                  </li>
                );
              } else {
                return (
                  <li
                    className={` ${
                      state.active === data.title ? "mm-active" : ""
                    }`}
                    key={index}
                  >
                    {data.content && data.content.length > 0 ? (
                      <Link
                        to={"#"}
                        className="has-arrow"
                        onClick={() => {
                          handleMenuActive(data.title);
                        }}
                      >
                        {data.iconStyle}
                        <span className="nav-text">{data.title}</span>
                      </Link>
                    ) : (
                      <NavLink to={data.to}>
                        {data.iconStyle}
                        <span className="nav-text">{data.title}</span>
                      </NavLink>
                    )}
                  </li>
                );
              }
            })}
          </ul>
       
      </PerfectScrollbar>
    </div>
  );
};

export default SideBar;
